import { useState } from 'react';

// PTO history table.
//
// Shows a footer proving the entries add up to the balance. Migration 114
// backfilled an opening-balance row for everyone, so they now do — before
// it, Julia Benevides' profile showed a 6.0 h balance above rows summing
// to -12.0 h, because migration 088 seeded pre-Monarch hours with a bare
// UPDATE and wrote no ledger row.
//
// `ledger.total` is summed SERVER-side over every row, not over the 20 the
// API returns — a footer that summed only what it could see would read as
// a lie for anyone with a year of weekly accruals. The row cap is now a
// collapse rather than a hard slice for the same reason: with the opening
// row added, a fixed 8-row window hides the very entry that makes the
// arithmetic work.

export function PtoHistoryTable({ history, currentUser, onDelete, ledger }) {
  const [showAll, setShowAll] = useState(false);
  if (!history || history.length === 0) return null;
  const rows = showAll ? history : history.slice(0, 8);
  const hidden = history.length - rows.length;
  // Tolerance matches migration 114's: 0.005 h is 18 seconds, below the one
  // decimal place rendered here.
  const total = ledger ? Number(ledger.total) : null;
  const balance = ledger ? Number(ledger.balance) : null;
  const tiesOut = total != null && balance != null && Math.abs(total - balance) < 0.005;
  return (
    <div style={{ marginTop: 12, borderTop: '1px solid #f0f0f0', paddingTop: 8 }}>
      <div style={{ fontSize: 11, fontWeight: 600, color: '#757575', textTransform: 'uppercase', letterSpacing: 0.6, marginBottom: 4 }}>PTO history</div>
      <table style={{ width: '100%', fontSize: 12 }}>
        <tbody>
          {rows.map((h) => (
            <tr key={h.id} style={{ borderBottom: '1px solid #fafafa' }}>
              <td style={{ padding: '4px 0', color: '#757575', whiteSpace: 'nowrap' }}>{h.created_at?.slice(0, 10) || ''}</td>
              <td style={{ padding: '4px 8px', textTransform: 'capitalize', color: '#37474f' }}>{h.type}</td>
              <td style={{ padding: '4px 0', textAlign: 'right', fontWeight: 600,
                            color: h.delta_hours > 0 ? '#2e7d32' : h.delta_hours < 0 ? '#c62828' : '#757575',
                            whiteSpace: 'nowrap' }}>
                {h.delta_hours > 0 ? '+' : ''}{Number(h.delta_hours).toFixed(1)}h
              </td>
              <td style={{ padding: '4px 0 4px 12px', color: '#9e9e9e', fontSize: 11 }}>
                {h.reason || (h.adjusted_by_name ? `by ${h.adjusted_by_name}` : '')}
              </td>
              {window.EmpireRoles.isOwner(currentUser) && (
                <td style={{ padding: '4px 0', textAlign: 'right', width: 24 }}>
                  <button onClick={() => onDelete(h)}
                    title="Delete this entry (reverses the balance change)"
                    style={{ background: 'transparent', border: 'none', color: '#c62828',
                              fontSize: 14, cursor: 'pointer', padding: '0 4px', lineHeight: 1 }}>×</button>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
      {hidden > 0 && (
        <button onClick={() => setShowAll(true)}
          style={{ background: 'transparent', border: 'none', color: '#37474f',
                    fontSize: 11, cursor: 'pointer', padding: '6px 0' }}>
          Show all {history.length} entries ({hidden} more)
        </button>
      )}
      {total != null && (
        <div style={{ marginTop: 4, paddingTop: 6, borderTop: '1px solid #f0f0f0',
                      fontSize: 11, color: tiesOut ? '#757575' : '#c62828' }}>
          {tiesOut
            ? `These ${ledger.entries} entries add up to ${total.toFixed(1)} h — the balance above.`
            : `These ${ledger.entries} entries add up to ${total.toFixed(1)} h, but the balance is ${balance.toFixed(1)} h. Something changed the balance without recording it.`}
        </div>
      )}
    </div>
  );
}
